<template>
  <section class="FormSect">
    <div v-if="title" class="title">
      <h3>{{ title }}</h3>
      <div v-if="sub" class="sub">
        {{ sub }}
      </div>
    </div>
    <slot />
  </section>
</template>

<script>
export default {
  props: {
    sub: String,
    title: String,
  },
}
</script>

<style lang="scss">
section.FormSect {
  border-bottom: 1px solid $border-color;
  padding: 1rem;

  > .title {
    margin-bottom: 1rem;

    h3 {
      color: $text-color-mid;
      margin-bottom: 0;
    }

    .sub {
      color: $grey;
      font-size: $h5;
      line-height: 1rem;
    }
  }

  p {
    margin: 1rem 0;
  }
}
</style>
